import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ChatIcon from "@mui/icons-material/Chat";
import SpeedIcon from "@mui/icons-material/Speed";
import SecurityIcon from "@mui/icons-material/Security";

function TheThreePrincipals() {
  const principles = [
    {
      icon: <ChatIcon sx={{ fontSize: 40 }} />,
      title: "Communication is Key",
      description:
        "In order to develop the best possible solution for our clients, we make an effort to deeply understand their needs and goals.",
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 40 }} />,
      title: "100% Hassle Free",
      description:
        "We take care of all the technical stuff, so you can focus on your business. From development to deployment to ongoing maintenance, your project is 100% our responsibility.",
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      title: "We're in it for the long run!",
      description:
        "Our job doesn't end with development or deployment. We also provide ongoing support and maintenance to ensure that your project is up and running smoothly at all times.",
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: 10,
        background: "#ffffff",
        position: "relative",
        paddingY: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h3"
            sx={{
              color: "#1a1a1a",
              fontWeight: 800,
              mb: 2,
            }}
          >
            Our Core Principles
          </Typography>

         
          <Typography
            variant="body1"
            sx={{
              color: "rgba(0,0,0,0.6)",
              maxWidth: "600px",
              mx: "auto",
              fontSize: "20px",
              lineHeight: 1.6,
            }}
          >
            The foundation of our success lies in these three fundamental
            principles.
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {principles.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  p: 4,
                  textAlign: "center",
                  background: "#ffffff",
                  borderRadius: "16px",
                  border: "1px solid rgba(0,0,0,0.05)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  height: "100%",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
                    borderColor: "#0A8EF2",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(4, 104, 191, 0.1)",
                    color: "#0A8EF2",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#0A8EF2",
                      color: "#fff",
                    },
                  }}
                >
                  {item.icon}
                </Box>

                {/* العنوان */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#1a1a1a",
                    mb: 1.5,
                  }}
                >
                  {item.title}
                </Typography>

                {/* الوصف */}
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(0,0,0,0.7)",
                    lineHeight: 1.6,
                    fontSize: "0.95rem",
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default TheThreePrincipals;
